import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./index.reuseable.css";
import "./index.animations.css";
import "./index.rwd.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/front_end_data_base/store.js"; // Ensure you export persistor from your store
import "./i18n";
import { configureSessionRequests, expireSession } from "./http_common.js";
import { configureStaffSocketSession } from "./components/staff_directory/universe-fdc-sprint1/services/fdcSocket";
import { configureSocketSession } from "./socket-io.js";

// ____________________________________________________________

configureSessionRequests(store);
configureSocketSession(store, expireSession);
configureStaffSocketSession(store, expireSession);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);
 